/* eslint-disable @next/next/no-img-element */

import * as React from 'react'
import { tw } from 'utils/classnames'
import { useTranslations } from 'next-intl'
import { useSortable } from '@dnd-kit/sortable'

import { CloseIcon } from 'primitives/icons/close'
import { Button } from '@repo/design-system-cf/components/button'

export function SortableItem({
  index,
  imageUrl,
  alt,
  handleDelete,
  imageName,
}: {
  index: number
  imageUrl: string
  alt: string
  handleDelete: (e: React.MouseEvent, index: number) => void
  imageName: string
}) {
  const t = useTranslations('pages.clubhouse.ask_cf.image_upload')
  const handleDeleteClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    handleDelete(e, index)
  }
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: imageName,
    transition: {
      duration: 150,
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    },
  })

  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
        transition: isDragging ? 'unset' : transition,
        touchAction: 'none', // Ensure touch actions are properly handled
      }
    : { touchAction: 'manipulation' }

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <div
        key={imageUrl}
        className={tw(
          'bg-cf-grey-25 group relative flex h-[134px] w-[134px] flex-col items-center justify-center overflow-visible rounded-[12px]',
        )}
      >
        <img
          src={imageUrl}
          alt={alt}
          height={0}
          className="rounded-2 size-[134px] object-cover cursor-pointer select-none sm:cursor-default"
        />
        <Button
          variant="tertiary"
          onClick={handleDeleteClick}
          className=" bg-primary-100 rounded-2 absolute size-4 top-2 right-2 items-center justify-center "
          aria-label={t('delete_aria_label')}
          size={'small'}
          iconRight={<CloseIcon className="text-cf-purple-900" />}
        />
      </div>
    </div>
  )
}
